import {
  TRANSPORT_METHOD_TYPE,
  TransportMethodType,
} from '@savgroup-front-common/core/api/Claim/getClaimGroupTransportPlanQuery';
import { formatSimpleAddressOneLine } from '@savgroup-front-common/core/formatters/address';
import { HandlingSpot, MessageType } from '@savgroup-front-common/types';

import messages from '../messages';

interface AdaptDepositCardAddressArgs {
  deposit: HandlingSpot;
  fallbackAddressStreet: string;
  getCountryTranslation: (country: string) => string;
}

interface DepositCardAddress {
  label?: MessageType;
  addressName?: string;
  addressStreet: string;
}

const HOME_PICKUP_METHOD_TYPES: TransportMethodType[] = [
  TRANSPORT_METHOD_TYPE.HomePickup,
  TRANSPORT_METHOD_TYPE.HomePickupProvidedBySeller,
  TRANSPORT_METHOD_TYPE.HomeIntervention,
];

export function adaptDepositCardAddress({
  deposit,
  fallbackAddressStreet,
  getCountryTranslation,
}: AdaptDepositCardAddressArgs): DepositCardAddress {
  const transportMethodType = deposit.transportPlanMethodType;
  const depositAddressStreet = formatSimpleAddressOneLine(
    deposit.address,
    getCountryTranslation,
  );

  if (transportMethodType === TRANSPORT_METHOD_TYPE.RelayPointDeposit) {
    const pickupAddress = deposit.pickupPointAddress?.address
      ? deposit.pickupPointAddress
      : deposit.address;

    return {
      label: messages.pickupPoint,
      addressName:
        deposit.pickupPointFullName ||
        `${pickupAddress?.firstname || ''} ${pickupAddress?.lastname || ''}`,
      addressStreet: formatSimpleAddressOneLine(
        pickupAddress,
        getCountryTranslation,
      ),
    };
  }

  if (
    transportMethodType &&
    HOME_PICKUP_METHOD_TYPES.includes(transportMethodType)
  ) {
    return {
      addressName: `${deposit.address?.firstname || ''} ${deposit.address?.lastname || ''}`,
      addressStreet: depositAddressStreet,
    };
  }

  return {
    label: messages.sendToCompany,
    addressStreet: depositAddressStreet || fallbackAddressStreet,
  };
}
